import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlatformViewHeaderComponent } from '../view-header/platform-view-header.component';

@Component({
  selector: 'app-platform-topnav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlatformViewHeaderComponent],
  template: `<app-platform-view-header />`,
  styleUrl: './platform-topnav.component.scss',
})
export class PlatformTopnavComponent {}
